function vacinasCovid(){
	return {
			"games":[
				{
					"informs":[
						{
							"text":"Vários tipos de vacinas estão sendo produzidas e testadas contra o vírus da COVID-19, o  SARS-CoV-2:",
							"title":"Vacinas para COVID-19",
							"image":"/images/games/informs/vacinasCovid/1.png",
						},
						{
							"text":" a) vacinas com vírus atenuados (inativos)  que são obtidos por tratamentos químicos e/ou térmicos que modificam o vírus, tornando-os incapazes de causarem a doença;",
							"title":"Vacinas para COVID-19",
							"image":"/images/games/informs/vacinasCovid/1.png",
						},
						{
							"text":"b) vacinas à base de fragmentos ou invólucros do vírus,  que contém as proteínas do vírus que serão reconhecidas  pelas células do sistema imune humano.",
							"title":"Vacinas para COVID-19",
							"image":"/images/games/informs/vacinasCovid/1.png",
						},
						{
							"text":"c) vacinas de vetores virais, ou seja,  introdução de genes do vírus SARS-CoV-2 em um vírus que não causa doença ao homem.",
							"title":"Vacinas para COVID-19",
							"image":"/images/games/informs/vacinasCovid/1.png",
						},
						{
							"text":"Os vírus modificados, injetados no homem, irão  produzir proteínas do coronavírus que estimulará o sistema imunológico a produzir as células de memória  contra o SARS-CoV-2.",
							"title":"Vacinas para COVID-19",
							"image":"/images/games/informs/vacinasCovid/1.png",
						},
						{
							"text":'d) vacinas com sequências de RNA viral, envolvidos em uma "cápsula de gordura”, que inseridas  no homem, penetram em células específicas.',
							"title":"Vacinas para COVID-19",
							"image":"/images/games/informs/vacinasCovid/1.png",
						},
						{
							"text":"Essas células irão sintetizar proteínas do  SARS-CoV-2 (em geral, a proteína da carapaça do vírus chamada spike) que estimulam  o sistema imune humano.",
							"title":"Vacinas para COVID-19",
							"image":"/images/games/informs/vacinasCovid/1.png",
						},
						{
							"text":'O sistema imunológico reconhece a proteína como sendo “do vírus" e produz as células de memória. Este tipo de vacina ainda não foi usada nas vacinas já licenciadas em uso.',
							"title":"Vacinas para COVID-19",
							"image":"/images/games/informs/vacinasCovid/1.png",
						},
						{
							"text":"As vacinas, algumas já disponíveis e outras em fase final de testes, inicialmente não conseguirão combater a pandemia, apenas protegerão o indivíduo.",
							"title":"Vacinas para COVID-19",
							"image":"/images/games/informs/vacinasCovid/1.png",
						},
						{
							"text":"Para que a vacinação acabe com a pandemia é necessário que cerca de 80%, ou de preferência,  toda a população mundial seja vacinada (aproximadamente 8 bilhões de pessoas).",
							"title":"Vacinas para COVID-19",
							"image":"/images/games/informs/vacinasCovid/1.png",
						},
						{
							"text":"Assim, mesmo com a vacinação, é importante que as medidas de prevenção sejam mantidas até que grande parte da população mundial esteja imunizada.",
							"title":"Vacinas para COVID-19",
							"image":"/images/games/informs/vacinasCovid/1.png",
						}
					],
					"pathImageGame":"midias/images/games/puzzles/vacinasCovid/1.png"
				}
			]
		};
}

export {vacinasCovid};
